// src/components/inbox/InboxEmptyColumn.jsx
import React from "react";

// The thread or client-record column while no thread is chosen. The spec has
// no copy for this state, so the column is deliberately blank rather than
// carrying an invented sentence.
const WIDTH = {
  thread: "tw-min-w-0 tw-flex-1 tw-bg-bg max-rail:tw-hidden",
  side: "tw-w-80 tw-flex-none tw-border-0 tw-border-l tw-border-solid tw-border-divider tw-bg-surface max-lg:tw-hidden",
};

export default function InboxEmptyColumn({ kind }) {
  return (
    <section
      data-slot={`inbox-col--${kind}`}
      className={WIDTH[kind]}
      aria-hidden="true"
    />
  );
}
